import React from "react";
import styled from "styled-components";
import { ButtonText } from "@loanbossinc/component-library";

const BannerContainer = styled.div`
  display: flex;
  background: #f7f2f2;
  width: calc(100% - 1px);
  justify-content: flex-start;
  align-items: center;
  padding: 15px 0;
  border: 1px solid #dadce0;
  border-top: none;
`;

const StyledButtonText = styled(ButtonText)`
  margin-right: 1em !important;
  .label {
    margin-right: 14px;
    font-family: "Work Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
  }
`;

const NotConfiguredMessageWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  padding-left: 1em;
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
`;

const RgiCalculationBanner = ({ history, routeData }) => {
  if (!routeData.reportGroup || !routeData.reportGroupInstance) {
    return null;
  }

  const { deal, reportGroup } = routeData;

  const { shouldCalculateDscr, shouldCalculateDebtYield } = reportGroup;

  if (!shouldCalculateDscr && !shouldCalculateDebtYield) {
    return null;
  }

  const goTo = () => {
    history.push(`/deal/${deal.id}/lender-reports/${reportGroup.id}`);
  };

  return (
    <BannerContainer>
      <NotConfiguredMessageWrapper>This report has DSCR and/or DY calculations that are not yet configured.</NotConfiguredMessageWrapper>
      <StyledButtonText label="See calculation details" iconName="launch" alignRight={false} onClick={goTo} />
    </BannerContainer>
  );
};

export default RgiCalculationBanner;
